import { AccountStep } from './account-step'
import { DetailsStep } from './details-step'
import { SecondProgression } from './second-progression'
import { ThirdProgression } from './third-progression'
import { BottomActions } from './actions'
import { ProgressSteps } from './breadcrumbs'
import { FormWrapper } from './form-wrapper'
import { CameraScan } from './camera-scan'
import { useStyles } from './styles'

interface IProps {
  camera?: boolean
}

export const ScannerScanCreate = ({ camera }: IProps) => {
  const classes = useStyles()

  return (
    <FormWrapper camera={camera}>
      <div className={classes.container}>
        <CameraScan />
        <ProgressSteps />
        <AccountStep />
        <SecondProgression />
        <ThirdProgression />
        <DetailsStep />
        <BottomActions />
      </div>
    </FormWrapper>
  )
}
